// packages/world-model/src/traits/switchable/index.ts

export * from './switchableTrait.js';
export * from './switchableBehavior.js';